import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_state_updating } from '@/hooks/_base/use_state_updating';
import { use_component_is_mounted_300 } from '@/hooks/is_mounted/use_component_is_mounted_300';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { useTranslation } from 'react-i18next';

interface Props {
  button_wrapper_class_name?: string;
}

export function BUTTON__language_change({ button_wrapper_class_name }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);
  const { is_authorized, user_settings } = use_slice_user(['is_authorized', 'user_settings']);
  const { is_mounted } = use_component_is_mounted_300();

  const [language, set_language] = use_state_updating(user_settings.regional_language);

  /*
   *
   */

  /*
   *
   */

  async function on_item_selected(value: string) {
    if (value == user_settings.regional_language) return;

    set_language(value);
    await FN_USER_SETTINGS__update(user_settings.clone({ regional_language: value }));
  }

  /*
   *
   */
  /*
   *
   */

  function render_items() {
    return Object.entries(CONSTANTS__shared.SUPPORTED_LANGUAGES).map(([key, value]) => (
      <UI_PRIMITIVE__dropdown_menu_item
        key={key}
        {...{ value, on_item_selected }}
        label={t((i18n_page_auth.base.button.change_language_dropdown as any)[value])}
        class_name_hovered_selected={'bg-accent'}
        className={`settings-dropdown-item text-page-foreground`}
      />
    ));
  }

  /*
   *
   */
  if (!is_authorized) return <></>;
  if (!CONSTANTS__shared.SUPPORTED_LANGUAGES.includes(language)) return <></>;

  return (
    <UI_PRIMITIVE__dropdown_menu>
      {/* Apply triggers to the elements directly */}
      <UI_PRIMITIVE__dropdown_menu_trigger asChild className="w-16 h-full flex flex-center">
        <div className={`${button_wrapper_class_name}`}>
          <UI_PRIMITIVE__button variant="no-border-on-bar" className="p-0 flex flex-center" size="square-5">
            <span className={`hover-animation ${is_mounted ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}>{language.capitalize()}</span>
          </UI_PRIMITIVE__button>
        </div>
      </UI_PRIMITIVE__dropdown_menu_trigger>

      <UI_PRIMITIVE__dropdown_menu_content side="right" className="rounded-lg">
        {render_items()}
      </UI_PRIMITIVE__dropdown_menu_content>
    </UI_PRIMITIVE__dropdown_menu>
  );
}
